import { post } from '@alltrails/shared/api';
import type ProResponse from '../types/ProResponse';

type Subscription = {
  app_source?: string;
  apple_pay_token?: string;
  appsflyer_id?: string;
  cc_token?: string;
  coupon_code?: string;
  google_pay_token?: string;
  os_version?: string;
  paypal_token?: string;
  price_code: string;
  recaptcha: string;
  uid: number;
};

// https://alpha.mostpaths.com/api/docs#tag/Need-Automation/operation/CreateSubscriptionUpgrade
export default async function createSubscriptionUpgrade(subscription: Subscription) {
  return post<ProResponse>('/api/alltrails/purchases/subscription_upgrades', subscription);
}
